<alarms type="history"></alarms>

